module.exports = __webpack_public_path__ + "img/bg3.3306e934.jpg";